import type { AppIconProps } from "../IconTypes";

export const GenerateTokenIcon: React.FC<AppIconProps> = ({
  width = 16,
  height = 16,
  className,
}) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="#1D9F81"
    >
      <rect fill="none" height="20" width="20" />
      <path
        d="M15.06,4.94L13,4l2.06-0.94L16,1l0.94,2.06L19,4l-2.06,0.94L16,7L15.06,4.94z M16,19l0.94-2.06L19,16l-2.06-0.94L16,13 l-0.94,2.06L13,16l2.06,0.94L16,19z M2.5,10c0,2.76,2.24,5,5,5s5-2.24,5-5s-2.24-5-5-5S2.5,7.24,2.5,10z M7.5,3.5 c3.59,0,6.5,2.91,6.5,6.5s-2.91,6.5-6.5,6.5S1,13.59,1,10S3.91,3.5,7.5,3.5L7.5,3.5z M10,7.5H5v1.25h1.75V13h1.5V8.75H10V7.5z"
        stroke="#1D9F81"
        strokeWidth="0.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
